import script from "./PatientCardNOTLIST.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientCardNOTLIST.vue?vue&type=script&setup=true&lang=ts"

import "./PatientCardNOTLIST.vue?vue&type=style&index=0&id=53203093&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53203093"]])

export default __exports__